import { Link } from "gatsby"
import React, { useRef } from "react"
import Card from "react-bootstrap/Card"

import styles from "./CardMinor.module.scss"

const CardMinor = ({ headingSize, title, text, url, internalLink, target }) => {
  const link = useRef()

  // Why proxylink?
  // "It's not disastrous in terms of comprehension, but verbose..."
  // (https://inclusive-components.design/cards/)

  const proxyLink = () => {
    link.current.click()
  }

  const Heading = headingSize

  return (
    <Card className={styles.card} onClick={proxyLink}>
      <div className={styles.content}>
        <Heading>
          {internalLink && (
            <Link to={url} ref={link}>
              {title}
            </Link>
          )}
          {!internalLink && (
            <a
              href={url}
              ref={link}
              target={target}
              rel={target === "_blank" ? "noopener noreferrer" : null}
            >
              {title}
            </a>
          )}
        </Heading>
        {text && <p>{text}</p>}
      </div>
    </Card>
  )
}

CardMinor.defaultProps = {
  headingSize: "h2",
  target: "_self",
}

export default CardMinor
